import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import { useAuth } from './../../../context/AuthContext';
import withPermission from './../../../utils/withPermission';

const EmployeeProjects = ({ EmployeeData }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);

  // Filter projects based on search query
  const filteredProjects = (EmployeeData?.projects || []).filter((proj) =>
    proj.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Paginate (you can adjust page size)
  const pageSize = 5;
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedProjects = filteredProjects.slice(startIndex, startIndex + pageSize);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  return (
    <React.Fragment>
      <div>
        <h4 className="mb-sm-0 font-size-18">Assigned Projects</h4>
        <div className="d-flex justify-content-end mb-2">
          <div className="search-box me-2">
            <div className="position-relative">
              <input
                type="text"
                className="form-control font-size-13"
                placeholder="Search..."
                value={searchQuery}
                onChange={handleSearchChange}
              />
              <i className="bx bx-search-alt search-icon" />
            </div>
          </div>
        </div>
        <br />

        <table className="table table-hover datatable dt-responsive nowrap view-table font-size-13">
          <thead>
            <tr>
              <th>#</th>
              <th>Project Name</th>
              <th>Project Number</th>
              <th>Role</th>
              <th>Assigned Date</th>
              {/* <th>Link</th> */}
            </tr>
          </thead>
          <tbody>
            {paginatedProjects.length > 0 ? (
              paginatedProjects.map((proj, index) => {
                const assignment = EmployeeData.assignments.find(
                  (a) => a.project_id === proj.id
                );
                return (
                  <tr key={proj.id}>
                    <td>{startIndex + index + 1}</td>
                    <td><Link to={`/project/details/${proj.id}`} className="dropdown-item">{proj.name}</Link></td>
                    <td>{proj.project_number || '-'}</td>
                    <td>{assignment?.role || '-'}</td>
                    <td>{assignment?.assigned_date || '-'}</td>
                    {/* <td>
                      <a
                        href={`/project/details/${proj.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View
                      </a>
                    </td> */}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6">No projects assigned</td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="d-flex justify-content-end pagination-sm">
          <ReactPaginate
            previousLabel={'<<'}
            nextLabel={'>>'}
            breakLabel={'...'}
            pageCount={Math.ceil(filteredProjects.length / pageSize)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageChange}
            containerClassName={'pagination justify-content-center pagination-sm'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            activeClassName={'active'}
            forcePage={currentPage - 1}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default EmployeeProjects;
